import TeacherSubComponent  from "../../containers/teacher";


const Teacher = TeacherSubComponent;
export default Teacher

